import React from 'react'

interface Props {
  title: string
  isAvailable: boolean
}

const RegionTitle = ({title, isAvailable}: Props): JSX.Element => {
  const comingSoonText = isAvailable ? '' : ' is coming soon'
  const selectText = isAvailable ? 'Select ' : ''

  const divTitle = `${selectText}${title}${comingSoonText}`

  const showSpan = !isAvailable
  const spanText = 'COMING SOON'

  return (
    <div className="region--title" title={divTitle}>
      {title}
      {showSpan && <span>{spanText}</span>}
    </div>
  )
}

export default RegionTitle
